import { useState, useCallback } from 'react';

export interface ColumnMapping {
  [key: string]: string;
}

interface UseColumnMappingReturn {
  columnMapping: ColumnMapping;
  availableColumns: string[];
  selectedColumn1: string;
  selectedColumn1Index: number;
  selectedColumn2: string;
  selectedColumn2Index: number;
  selectedColumn3: string;
  selectedColumn3Index: number;
  hasSeparateDateAndTime: boolean;
  setColumnMapping: (mapping: ColumnMapping) => void;
  setAvailableColumns: (columns: string[]) => void;
  setSelectedColumn1: (column: string) => void;
  setSelectedColumn1Index: (index: number) => void;
  setSelectedColumn2: (column: string) => void;
  setSelectedColumn2Index: (index: number) => void;
  setSelectedColumn3: (column: string) => void;
  setSelectedColumn3Index: (index: number) => void;
  setHasSeparateDateAndTime: (value: boolean) => void;
  updateMapping: (oldColumn: string, newColumn: string) => void;
  resetColumnMappings: () => void;
  reset: () => void;
}

export const useColumnMapping = (): UseColumnMappingReturn => {
  const [columnMapping, setColumnMapping] = useState<ColumnMapping>({});
  const [availableColumns, setAvailableColumns] = useState<string[]>([]);
  const [selectedColumn1, setSelectedColumn1] = useState<string>('');
  const [selectedColumn1Index, setSelectedColumn1Index] = useState<number>(-1);
  const [selectedColumn2, setSelectedColumn2] = useState<string>('');
  const [selectedColumn2Index, setSelectedColumn2Index] = useState<number>(-1);
  const [selectedColumn3, setSelectedColumn3] = useState<string>('');
  const [selectedColumn3Index, setSelectedColumn3Index] = useState<number>(-1);
  const [hasSeparateDateAndTime, setHasSeparateDateAndTime] = useState<boolean>(false);

  const updateMapping = useCallback((oldColumn: string, newColumn: string) => {
    setColumnMapping(prev => ({
      ...prev,
      [oldColumn]: newColumn
    }));
  }, []);

  const resetColumnMappings = useCallback(() => {
    setSelectedColumn1('');
    setSelectedColumn1Index(-1);
    setSelectedColumn2('');
    setSelectedColumn2Index(-1);
    setSelectedColumn3('');
    setSelectedColumn3Index(-1);
    setHasSeparateDateAndTime(false);
    setColumnMapping({});
  }, []);

  const reset = useCallback(() => {
    resetColumnMappings();
    setAvailableColumns([]);
  }, [resetColumnMappings]);

  return {
    columnMapping,
    availableColumns,
    selectedColumn1,
    selectedColumn1Index,
    selectedColumn2,
    selectedColumn2Index,
    selectedColumn3,
    selectedColumn3Index,
    hasSeparateDateAndTime,
    setColumnMapping,
    setAvailableColumns,
    setSelectedColumn1,
    setSelectedColumn1Index,
    setSelectedColumn2,
    setSelectedColumn2Index,
    setSelectedColumn3,
    setSelectedColumn3Index,
    setHasSeparateDateAndTime,
    updateMapping,
    resetColumnMappings,
    reset
  };
};